const FALLBACK_API_GATEWAY_BASE_URL = 'https://apigw.paziresh24.com';

/**
 * Client `publicRuntimeConfig` is often empty at module-eval (and Docker
 * `next build` has no API_GATEWAY_BASE_URL). Interpolating it yields a relative
 * `undefined/...` URL and Next catch-all pages then 500.
 */
export function resolveApiGatewayBaseUrl(raw?: string | null): string {
  const value = raw?.trim();
  if (!value || value === 'undefined' || value === 'null') {
    return FALLBACK_API_GATEWAY_BASE_URL;
  }
  if (!/^https?:\/\//i.test(value)) {
    return FALLBACK_API_GATEWAY_BASE_URL;
  }
  return value.replace(/\/+$/, '');
}

export function resolveApiGatewayPath(path: string, raw?: string | null): string {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${resolveApiGatewayBaseUrl(raw)}${suffix}`;
}
